import React from "react";
import {
  Box,
  Button,
  Text,
  Heading,
  Flex,
  Image,
  ThemeProvider,
} from "@catchoftheday/cg-components";
import { Footer, EnhancedHeader } from "@catchoftheday/header-app";

type ErrorPageProps = {
  host?: string;
  errorCode?: number;
};

export const ErrorPage = ({ host = "", errorCode = 404 }: ErrorPageProps) => {
  return (
    <ThemeProvider>
      <Box>
        <EnhancedHeader host={host} />

        <Box
          as="main"
          style={{
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundImage:
              "url('https://s.catch.com.au/static/catch/images/404-cb83cbebf7.jpg')",
          }}
        >
          <Flex
            py="4.375rem"
            flexDirection="column"
            alignItems="center"
            bg="rgba(0, 100, 228, .8)"
          >
            <Box>
              <Image
                src="https://s.catch.com.au/static/catch/images/logo-83d9b21199.svg"
                width="100%"
                height="100%"
                alt="Catch"
              />
            </Box>
            <Heading.h1
              fontWeight="700"
              fontSize="8.75rem"
              color="white"
              marginTop={0}
              marginBottom="0.875rem"
              style={{ textShadow: "0 4px 4px rgb(0 0 0 / 25%)" }}
            >
              {errorCode}
            </Heading.h1>
            <Text color="white" mb={3} mt={0} fontWeight="600">
              Looks like the page you're after doesn't exist.
            </Text>
            <Text color="white" mb={3} mt={0} fontWeight="600">
              Don't worry, it can happen to the best of us.
            </Text>
            <Text color="white" mb={3} mt={0} fontWeight="600">
              Search for millions of other reasons to Checkout Catch!
            </Text>
            <Button
              aria-label="go to top of page"
              value="go to top of page"
              mt="28px"
            >
              Let's Go
            </Button>
          </Flex>
        </Box>

        <Footer />
      </Box>
    </ThemeProvider>
  );
};
